import 'dragster';

import Vue from 'vue';


Vue.directive('focus-container', {
    inserted(el, binding, vnode) {
        el.addEventListener('focusout', (ev) => {
            if (!el.contains(ev.relatedTarget)) {
                vnode.child.$emit('focus-outside');
            }
        });
    },
});

Vue.directive('dragster', {
    bind(el, { value }) {
        if (value) {
            el.__dragster__ = new Dragster(el);
            el.__dragsterListener__ = () => el.__dragster__.reset();

            el.addEventListener('drop', el.__dragsterListener__);
        }
    },
    unbind(el) {
        el.removeEventListener('drop', el.__dragsterListener__);

        el.__dragster__?.removeListeners();

        delete el.__dragsterListener__;
        delete el.__dragster__;
    },
});
